import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

import { Tooltip, tooltipClasses } from "scmp-app/components/common/tooltip";

import IconUpvoteOff from "./icon-upvote-off.svg";
import IconUpvoteOn from "./icon-upvote-on.svg";

export const StyledIconUpvoteOff = styled(IconUpvoteOff)``;
export const StyledIconUpvoteOn = styled(IconUpvoteOn)``;

export const Container = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  padding-inline: 16px;

  border: 1px solid #001246;
  border-radius: 5px;

  background: #ffffff;

  cursor: pointer;

  ${StyledIconUpvoteOff}, ${StyledIconUpvoteOn} {
    inline-size: 20px !important;
    block-size: 20px !important;
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    flex-direction: column;
    gap: 5px;

    padding: 0;

    border: 0;

    ${StyledIconUpvoteOff}, ${StyledIconUpvoteOn} {
      inline-size: 27px !important;
      block-size: 28px !important;
    }
  }
`;

export const StyledTooltip = styled(Tooltip)`
  & .${tooltipClasses.tooltip} {
    inline-size: 136px;
    padding: 14px;

    color: #ffffff;
    font-weight: 400;
    font-size: 15px;
    font-family: ${fontRobotoCondensed};
    font-style: normal;
    line-height: normal;

    background-color: #001246;
  }

  & .${tooltipClasses.arrow} {
    color: #001246;
    font-size: 16px;

    ${props => props.theme.breakpoints.up("tablet")} {
      transform: translate(0, 12px) !important;
    }
  }

  /** overwrite the default tooltip position on mobile devices */
  &
    .${tooltipClasses.tooltip}.${tooltipClasses.tooltipArrow}.${tooltipClasses.tooltipPlacementBottom} {
    margin-block-start: 26px;

    transform: translateX(17px) !important;
  }

  /** overwrite the default arrow style on mobile devices */
  & .${tooltipClasses.tooltipPlacementBottom} .${tooltipClasses.arrow} {
    inset-block-start: 1px;
    inset-inline-start: -17px !important;
  }

  /** overwrite the default tooltip position on desktop devices */
  &
    .${tooltipClasses.tooltip}.${tooltipClasses.tooltipArrow}.${tooltipClasses.tooltipPlacementRight} {
    transform: translateY(-4px) !important;
  }
`;

export const StyledButton = styled.button`
  color: inherit;
  font: inherit;

  border: none;

  background-color: transparent;

  cursor: pointer;

  svg {
    inline-size: 100%;
    block-size: 100%;
  }
`;

export const Count = styled.div`
  color: #001246;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 18px; /* 16.9px */
  letter-spacing: -0.5px;
  text-align: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-weight: 500;
    font-size: 13px;
    font-family: ${fontRobotoCondensed};
    line-height: 17px; /* 100% */
  }
`;
